import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "./spinner/spinner.component";
import { IconModule } from "../icon/icon.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ClipboardModule } from "ngx-clipboard";
import { NgClickOutsideDirective } from "ng-click-outside2";
import { MarkdownModule } from "ngx-markdown";
import { SelectStorageUpgradeComponent } from "./select-storage-upgrade/select-storage-upgrade.component";

@NgModule({
  declarations: [SpinnerComponent, SelectStorageUpgradeComponent],
  imports: [
    CommonModule,
    IconModule,
    FormsModule,
    ClipboardModule,
    NgClickOutsideDirective,
    MarkdownModule.forRoot(),
  ],
  exports: [
    SpinnerComponent,
    IconModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    NgClickOutsideDirective,
    MarkdownModule,
    SelectStorageUpgradeComponent,
  ],
})
export class SharedModule {}
